module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-分享-浅.3de33.png";